import React, { useState } from 'react'
import { FcExpand, FcCollapse } from "react-icons/fc";
import "./Projects.css"
import Zoom from 'react-reveal/Zoom';

function ProjectList({ name, des, projectlink, techused }) {


    const [show, setShow] = useState(false);

    const handleShowAndCollabse = () => {
        setShow(!show);
    }

    const colors = [
        "#FFA233",
        "#336BFF",
        "#6133FF",
        "#C433FF",
        "#FF33DD",
        "#FF337D",
        "#FFF333",
        "#33FFAC",
        "#33DAFF",
        "#8A33FF",
        "#8DFF33",
        "#33FFDD",
      ];
    


    return (
        <Zoom>
            <div id='project' className={show ? "project-list-opend porject-list" : "porject-list"} onClick={handleShowAndCollabse}
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}

            >
                <div className="titel-and-collabse-option">
                    <h5> {name}</h5>
                    <p>{show ? <FcCollapse size={20} /> : <FcExpand size={20} />}</p>
                </div>


                <div className="describtion">
                    {show ? <p>{des}</p> : <p>{des.substring(0, 50)}...</p>}
                </div>

                <div className="row">
                    {techused && techused.map((tech, index) => (
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12" key={index}>
                            <div className="tech-used-in-project" >
                                <p style={{backgroundColor: colors[index]}}>{tech.techname}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="live-demo-button">
                    <a target="_" href={projectlink}>Live Demo</a>
                </div>
            </div>
        </Zoom>
    )
}

export default ProjectList